import React from 'react';
import { CheckIcon, SparklesIcon, RocketIcon, BuildingIcon, TrendingUpIcon } from 'lucide-react';
const pricingTiers = [{
  name: 'Pilot Sprint',
  duration: '4 weeks',
  price: '$18,000',
  priceSubtext: 'fixed',
  icon: SparklesIcon,
  color: 'from-blue-500 to-cyan-500',
  description: 'Prove the lift, produce reusable assets',
  features: ['ICP + messaging matrix', 'AI landing page + CRO tests', 'Outbound sequences + SDR copilot', 'Ad system + tracking', 'Baseline dashboards', 'Decide scale plan'],
  cta: 'Start Pilot',
  popular: false
}, {
  name: 'Starter',
  duration: 'SMB',
  price: '$5,000',
  priceSubtext: '/month + $8k setup',
  icon: RocketIcon,
  color: 'from-purple-500 to-pink-500',
  description: 'One product + 1-2 channels',
  features: ['AI brand & voice guide', 'Programmatic landing page', 'Website chatbot', 'Outbound engine', 'Basic analytics', '25-35 hrs/month', 'Overage $200/hr'],
  cta: 'Get Started',
  popular: true
}, {
  name: 'Growth',
  duration: 'Mid-market',
  price: '$15,000',
  priceSubtext: '/month + $25k setup',
  icon: TrendingUpIcon,
  color: 'from-orange-500 to-red-500',
  description: '2-3 products + 3-4 channels',
  features: ['Everything in Starter, plus:', 'ABM playbooks', 'Ad ops optimization', 'RAG knowledge bot', 'Multi-touch attribution', 'A/B testing at scale', 'Sales copilot + call notes', '60-80 hrs/month', 'Overage $225/hr'],
  cta: 'Scale Revenue',
  popular: false
}, {
  name: 'Enterprise',
  duration: 'Multi-BU',
  price: '$40,000',
  priceSubtext: '/month + $60k setup',
  icon: BuildingIcon,
  color: 'from-indigo-500 to-purple-500',
  description: 'Company-wide rollout with governance',
  features: ['Everything in Growth, plus:', 'SSO & data pipelines', 'RevOps automation', 'Custom LLM workflows', 'Team training', 'Dedicated success manager', '150-200 hrs/month', 'Overage $250/hr'],
  cta: 'Contact Sales',
  popular: false
}];
export function Pricing() {
  const handleBookCall = () => {
    window.open('https://calendly.com', '_blank');
  };
  return <div className="py-24 bg-white" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-157">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-158">
            Transparent Pricing
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-159">
              That Scales With You
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4" data-id="element-160">
            Choose the plan that fits your stage. Add performance fees to align
            incentives.
          </p>
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 rounded-full px-6 py-3" data-id="element-161">
            <SparklesIcon className="w-5 h-5 text-blue-600" data-id="element-162" />
            <span className="font-semibold text-gray-900" data-id="element-163">
              Expert Strategists + AI Tools = Unmatched Results
            </span>
          </div>
        </div>
        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-164">
          {pricingTiers.map((tier, index) => {
          const Icon = tier.icon;
          return <div key={index} className={`relative bg-white rounded-2xl p-6 border-2 transition-all hover:shadow-2xl ${tier.popular ? 'border-purple-500 shadow-xl scale-105' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-165">
                {/* Popular badge */}
                {tier.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-166">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-167">
                      Most Popular
                    </div>
                  </div>}
                {/* Icon */}
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${tier.color} flex items-center justify-center mb-4`} data-id="element-168">
                  <Icon className="w-6 h-6 text-white" data-id="element-169" />
                </div>
                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-170">
                  {tier.name}
                </h3>
                <p className="text-sm text-gray-500 mb-4" data-id="element-171">{tier.duration}</p>
                {/* Price */}
                <div className="mb-4" data-id="element-172">
                  <div className="text-4xl font-bold text-gray-900" data-id="element-173">
                    {tier.price}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-174">
                    {tier.priceSubtext}
                  </div>
                </div>
                {/* Description */}
                <p className="text-gray-600 mb-6" data-id="element-175">{tier.description}</p>
                {/* Features */}
                <ul className="space-y-3 mb-6" data-id="element-176">
                  {tier.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-177">
                      <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-178" />
                      <span data-id="element-179">{feature}</span>
                    </li>)}
                </ul>
                {/* CTA */}
                <button onClick={handleBookCall} className={`w-full py-3 rounded-lg font-semibold transition-all ${tier.popular ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:shadow-lg' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'}`} data-id="element-180">
                  {tier.cta}
                </button>
              </div>;
        })}
        </div>
        {/* Performance Fee Option */}
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl p-8 border-2 border-blue-200" data-id="element-181">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-182">
            <div className="flex-1" data-id="element-183">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-184">
                <TrendingUpIcon className="w-6 h-6 text-blue-600" data-id="element-185" />
                Add Performance Fees
              </h3>
              <p className="text-gray-700 mb-2" data-id="element-186">
                Stack with any tier: 5-10% of incremental qualified pipeline or
                2-4% of incremental revenue
              </p>
              <p className="text-sm text-gray-600" data-id="element-187">
                Capped at 3× monthly retainer • Only pay when we deliver results
              </p>
            </div>
            <button onClick={handleBookCall} className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap" data-id="element-188">
              Discuss Custom Terms
            </button>
          </div>
        </div>
        {/* ROI Example */}
        <div className="mt-12 text-center" data-id="element-189">
          <p className="text-gray-600 mb-2" data-id="element-190">
            <span className="font-bold text-gray-900" data-id="element-191">Example ROI:</span> Growth
            plan costs $205k/year
          </p>
          <p className="text-gray-600" data-id="element-192">
            Break-even at just{' '}
            <span className="font-bold text-blue-600" data-id="element-193">12 extra deals</span>{' '}
            (assuming $30k ACV, 60% margin)
          </p>
        </div>
      </div>
    </div>;
}